// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f7265df","239":"607b63b7","732":"a303b630"}[chunkId] + ".chunk.js";
};